import { WSAlert } from "@wingspanhq/fe-component-library";
import React from "react";

export const PLGLDiscontinuedWarning: React.FC = () => (
  <WSAlert
    theme="warning"
    icon="alert"
    mb="XL"
    title="Professional and General Liability insurance is no longer available through Wingspan."
    action={{
      text: "Get coverage from Equal Parts",
      onClick: () =>
        window.open(
          "https://get.equalparts.ai/",
          "_blank",
          "noopener,noreferrer"
        )
    }}
  >
    We stopped accepting new enrollments on September 1, 2026. You can get the
    same coverage directly from Equal Parts.
  </WSAlert>
);
